export default {
    indexOccupancyConsolidations:    { method: 'get',  url: 'occupancy_consolidations' },
    generateOccupancyConsolidation:  { method: 'post', url: 'occupancy_consolidations/generate' },
    downloadOccupancyConsolidation:  { method: 'get',  url: 'occupancy_consolidations/{id}/download', responseType: 'blob' },
}
